import { FC } from 'react';

import classNames from 'classnames';

import { IUtilProps } from './util.interface';
import styles from './util.module.scss';

const Util: FC<IUtilProps> = props => {
  const {
    children,
    marginX,
    marginY,
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
    paddingX,
    paddingY,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    modRelative,
    className = '',
  } = props;

  const utilClassNames = classNames(styles.util, className, {
    [styles.relative]: modRelative,
  });

  const marginsStyles = {
    marginTop: marginY || marginTop,
    marginBottom: marginY || marginBottom,
    marginRight: marginX || marginRight,
    marginLeft: marginX || marginLeft,
  };

  const paddingStyles = {
    paddingTop: paddingY || paddingTop,
    paddingBottom: paddingY || paddingBottom,
    paddingRight: paddingX || paddingRight,
    paddingLeft: paddingX || paddingLeft,
  };

  const stylesObj = {
    ...marginsStyles,
    ...paddingStyles,
  };

  return (
    <div className={utilClassNames} style={stylesObj}>
      {children}
    </div>
  );
};

export { Util };
